import React from 'react';
import { withRouter } from 'react-router-dom';
import { Form, Field, Loader } from '@smartplatform/ui';

import { useGetRecord } from 'root/admin/components/hooks';
import { Title } from 'root/admin/components';

const MediaAccreditationEdit = ({ match, rootPath, tabName }) => {
	const { id, jid } = match.params;
	const options = {};
	const record = useGetRecord({ model: 'MediaJournalist', id: jid, options, tabName });

	if (!record) {
		return <Loader />;
	}

	const beforeSave = record => {
		record.mediaTitleId = id;
	};

	return (
		<div>
			<Title record={record} name="Журналист" />
			<Form record={record} rootPath={`${rootPath}/mediatitles/${id}`} beforeSave={beforeSave}>
				<Field property="name" label="ФИО сотрудника" />
				<Field property="position" label="Должность" />
			</Form>
		</div>
	);
};

export default withRouter(MediaAccreditationEdit);
